"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInitialContentChange = void 0;

var isInitialContentChange = function isInitialContentChange(handler) {
  var called = false;
  return function (oldState, newState) {
    if (!called && !oldState.plainText() && newState.plainText()) {
      handler();
      called = true;
    }
  };
};

exports.isInitialContentChange = isInitialContentChange;